import { FormEvent, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Spinner from '@/components/Spinner/Spinner'
import profileService from '@/services/profile.service'

const ForgotPassword = () => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState('')
  const [email, setEmail] = useState('')

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    profileService
      .forgotPassword(email)
      .then(() => setSuccess('Password reset request has been emailed to ' + email))
      .catch((err) => setError(err.message))
      .finally(() => setIsLoading(false))
  }

  return (
    <Main>
      <Container small>
        <ExplicitHead
          description='EDHREC Forgot Password'
          keywords='EDHREC,forgot,password'
          title='Forgot Password | EDHREC'
        />
        <SimpleHeader>Forgot Password</SimpleHeader>
        <Panel>
          <form className='d-grid gap-3 pb-3' onSubmit={onSubmit}>
            <FloatingLabel label='Email'>
              <Form.Control onChange={(e) => setEmail(e.target.value)} placeholder='Email' type='email' value={email} />
            </FloatingLabel>
            <Button disabled={isLoading} size='lg' type='submit' variant='primary'>
              {isLoading ? <Spinner /> : 'Submit'}
            </Button>
            {error && <Alert variant='danger'>{error}</Alert>}
            {success && <Alert variant='success'>{success}</Alert>}
          </form>
        </Panel>
      </Container>
    </Main>
  )
}

export default ForgotPassword
